export default "__VITE_ASSET__k1cW$C46__"